import { Injectable } from '@angular/core';

@Injectable()

export class Globals {
    /* QA */

     //APIURL: string = 'https://odaksaqa.odaksolutions.in/api';
     //APIURLFN: string = 'https://odakfnqa.odaksolutions.in/api';
     //APIURLFF: string = 'https://odaksaqa.odaksolutions.in/ffddev/api';
     //APIURL_LA: string = 'https://odaklaqa.odaksolutions.in/api';
     //APIURLUSER: string = 'https://odaksaqa.odaksolutions.in/ffddev/api';




     /* UAT */
    //APIURL: string = 'https://odaksauat.odaksolutions.in/api';
    //APIURLFN: string = 'https://odakfnuat.odaksolutions.in/api';
    //APIURLFF: string = 'https://odaksauat.odaksolutions.in/ffddev/api';
    //APIURL_LA: string = 'https://odaklauat.odaksolutions.in/api';
    //APIURLUSER: string = 'https://odaksauat.odaksolutions.in/ffddev/api';


    /** Freighteiz **/

    APIURL: string = 'https://sa-navioindia.freighteiz.com/api';
    APIURLFN: string = 'https://fn-navioindia.freighteiz.com/api';
    APIURLFF: string = 'https://sa-navioindia.freighteiz.com/ffddev/api';
    APIURL_LA: string = 'https://la-navioindia.freighteiz.com/api';
    APIURLUSER: string = 'https://sa-navioindia.freighteiz.com/ffddev/api';

    /** Skib **/

    //APIURL: string = 'https://sa-skib.freighteiz.com/api';
    //APIURLFN: string = 'https://fn-skib.freighteiz.com/api';
    //APIURLFF: string = 'https://sa-skib.freighteiz.com/ffddev/api';
    //APIURL_LA: string = 'https://la-skib.freighteiz.com/api';
    //APIURLUSER: string = 'https://sa-skib.freighteiz.com/ffddev/api';

    /** NavioUat **/

    //APIURL: string = 'https://sa-naviouat.freighteiz.com/api';
    //APIURLFN: string = 'https://fn-naviouat.freighteiz.com/api';
    //APIURLFF: string = 'https://sa-naviouat.freighteiz.com/ffddev/api';
    //APIURL_LA: string = 'https://la-naviouat.freighteiz.com/api';
    //APIURLUSER: string = 'https://sa-naviouat.freighteiz.com/ffddev/api';


    /** Nikins **/

    //APIURL: string = 'https://sa-nikins.freighteiz.com/api';
    //APIURLFN: string = 'https://fn-nikins.freighteiz.com/api';
    //APIURLFF: string = 'https://sa-nikins.freighteiz.com/ffddev/api';
    //APIURL_LA: string = 'https://la-nikins.freighteiz.com/api';
    //APIURLUSER: string = 'https://sa-nikins.freighteiz.com/ffddev/api';

    /** Sahel **/

    //APIURL: string = 'https://sa-sahel.freighteiz.com/api';
    //APIURLFN: string = 'https://fn-sahel.freighteiz.com/api';
    //APIURLFF: string = 'https://sa-sahel.freighteiz.com/ffddev/api';
    //APIURL_LA: string = 'https://la-sahel.freighteiz.com/api';
    //APIURLUSER: string = 'https://sa-sahel.freighteiz.com/ffddev/api';

    //APIURL: string = 'https://localhost:44308/api';
    
}

